import { Home, FileCheck2, Wallet, RefreshCw } from "lucide-react";
import { Reveal } from "./Reveal";
import { AUDIENCE } from "./data";

const ICONS = { home: Home, file: FileCheck2, wallet: Wallet, refresh: RefreshCw };

export const Audience = () => (
    <section id="cocok" className="scroll-mt-20 bg-white py-20 lg:py-28" data-testid="audience-section">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <Reveal className="mx-auto max-w-2xl text-center">
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#123E65]">Untuk Siapa</p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#1C2533] sm:text-4xl" data-testid="audience-heading">
                    Kelas Ini <span className="font-accent italic text-[#123E65]">Cocok Buat Siapa?</span>
                </h2>
            </Reveal>
            <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="audience-cards">
                {AUDIENCE.map((a, i) => {
                    const Icon = ICONS[a.icon];
                    return (
                        <Reveal key={a.title} delay={i * 0.08}>
                            <div className="group h-full rounded-2xl border border-[#071B37]/8 bg-[#F8F6F1] p-7 transition-all duration-300 hover:-translate-y-2 hover:bg-white hover:shadow-[0_16px_40px_rgba(7,27,55,0.12)]" data-testid={`audience-card-${i + 1}`}>
                                <div className="mb-5 inline-flex rounded-full border border-[#DDB56C]/40 bg-white p-3.5 shadow-sm">
                                    <Icon className="h-6 w-6 text-[#123E65]" strokeWidth={1.5} />
                                </div>
                                <h3 className="text-lg font-bold text-[#1C2533]">{a.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-[#1C2533]/70">{a.desc}</p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
